import React, {useEffect, useState} from "react";
import Layout from "../../../components/mobile/Layout/layoutmobile";
import {getProductByTab, getcategorymenu} from "../../../service/myProductService";
import {responsiveproductlistmobile4}  from "../../../utils/constant";
import {Item} from "../../../components/mobile/product";
import HeaderMobile from "../../../components/mobile/header/headerv2";
import {Helmet} from "react-helmet";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import './css/san-pham.css';
import { pushtracking } from "../../../service/trackingService";
import { useLocation } from "@reach/router";

const Danhmuc = ()=> {
    const location = useLocation();
    const [category, setCategory] = useState([]);
    const [childCategory, setChildCategory] = useState([]);
    const [categoryId, setCategoryId] = useState('');
    const [childBefor, setChildBefor] = useState([]);
    const getDataCategory=()=>{
        try{
            getcategorymenu().then((response) => {
                if(response.status == 200 && response.message.length >0  && response.message !== "Không tìm thấy dữ liệu."){
                    setCategory(response.message);
                    var obj = {};
                    setCategoryId(response.message[0]?._id);
                    response.message.forEach(element => {
                        obj[element._id] = element.children[0]?.children;
                    });
                    setChildCategory(obj);
                    setChildBefor(response.message[0].children[0]?.children);
                }               
              });
        }catch(e){
            console.log(e);
        }
    }

    const [itemData, setItemData] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [loadMoreStart, setLoadMoreStart] = useState(0);

    const getDataProductByTab=(tab, start)=>{
        try{
            getProductByTab(tab, start, 6).then((response) => {
                if(response.status === 200 && response.message.length >0  && response.message !== "Không tìm thấy dữ liệu."){
                    setItemData((prevData) => [...prevData, ...response.message]);
                    setTotalItem(response.metadata?.total_item);
                }            
                });
        }catch(e){
            console.log(e);
        }
    }
    const [meta, setMeta] = useState();
    useEffect(()=>{
        setTabProduct(0)
        setItemData([]);
        getDataCategory();
        getDataProductByTab(0,0);
        try{
            var _sku_list = [];
            itemData.forEach((item)=>{
                _sku_list.push(item?.sku);
            });
            pushtracking(window.localStorage.getItem('sessionId')??null,
            window.localStorage.getItem('_id')??null,
            window.localStorage.getItem('phone')??null ,
            location.pathname, "Danh sách sản phẩm", 0,0,'index','inWeb',_sku_list,'Website Mobile').then((response)=>{
                console.log('send tracking');
            });
        }catch(e){console.log(e)}
    },[])
    const handleClickGetProductByCategiryId=(id)=>{
        setCategoryId(id);
        setChildBefor(childCategory[id]);
    }
    const [groupId, setGroupId] = useState('');
    const handleClickGetProductBygroupId=(id, name, groupId)=>{
        setGroupId(id);
        console.log(groupId);
        window.localStorage.setItem("titleCate", name);
        window.localStorage.getItem("titleCate");
        window.location.href = '/mobile/danh-sach-san-pham.html?function='+groupId;
    }
    const [tabProduct, setTabProduct] = useState(0);
    const handleLoadProduct=(tab, start)=>{
        setTabProduct(tab);
        setTotalItem(0);
        setItemData([]);
        getDataProductByTab(tab,0);
    }
    const handleLoadMore = (e) => {
        setLoadMoreStart(0);
        const newStart = loadMoreStart + 1;
        setLoadMoreStart(newStart);
        getDataProductByTab(tabProduct,0);
      };
     
    const handleRedirect =(uri)=>{
        window.location.href = uri;
    }
    const InfiniteScroll = ({ loadMore }) => {
        useEffect(() => {
          const handleScroll = () => {
            var check = Math.abs(parseInt(window.innerHeight +document.documentElement.scrollTop) - parseInt(document.documentElement.offsetHeight)) 
            if (check === 0 || check === 1){
                loadMore();
             }
          };
      
          window.addEventListener("scroll", handleScroll);
          return () => {
            window.removeEventListener("scroll", handleScroll);
          };
        }, [loadMore]);
      
        return null;
    };
  return (
   <Layout>
    <Helmet>
        <body className="bg-white"/>
    </Helmet>
    <HeaderMobile Type={'headerShowInputSearch'} showBanner={false} linkBanner="" showText = {true} showSearchIcon= {true} showNoti = {true} showCart = {true} showTitle = {""} />     
    <div className="row mgt-10 list-banner-category">
    {
        category.length>0?(
            <Carousel key="category"
            responsive={responsiveproductlistmobile4}
            controls={false}
            indicators={false}
            nextIcon="" 
            nextLabel=""
            >
            {
                category.map((item, i)=>{
                    return <div key={i} className={categoryId === item._id ? ("select-border-bt"):("border-bottom") } onClick={()=>handleClickGetProductByCategiryId(item._id)}>
                    <div className='row'>
                        <div className='col-12 in-f'><div className="box-img-category"><img className="icon-img" src={item.icon?.unselect} /></div></div>
                        <div className='col-12 in-f pdy-10'><span className="text-item-category">{
                    item?.name?.length > 10 ? ( (item?.name).substring(0, 10) +'...') :(item?.name)
                    }</span></div>
                    </div>
                </div>
                })
            }
            </Carousel>
            
        ):(null)
    }
     <div className="icon-menu list-menu-category in-f">
            <div className='row mgx-0' onClick={()=>handleRedirect('/mobile/danh-muc.html')}>
                <div className='col-12 pdx-0'><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/category_menu.png" alt="icon"/></div>
            </div>
        </div>
    </div> 
    <div className="row list-style-category mgt-10 mgb-5">
    {
        childBefor?.length>0?(
        childBefor?.map((item, i)=>{
            return <div key={i} className={groupId === item._id ? ("col-3 detail-style-category selected-color-red"):("col-3 detail-style-category") } 
            onClick={()=>handleClickGetProductBygroupId(item._id, item?.name,item.items[0])}>
                    <div className='row pdx-5'>
                        <div className='col-12 pdx-0'>
                            <img className="icon-img-menu" src={item.icon?.selected} alt={item.name}/>
                        </div>
                        <div className='col-12 category-item-detail d-flex'><span>
                        {
                            item?.name?.length > 20 ? ( (item?.name).substring(0, 20) +'...') :(item?.name)
                        }
                            </span></div>
                    </div>
                </div>
        })
        ):(null)
    }
    <div className="col-3 detail-style-category">
            <div className='row pdx-5' onClick={()=>handleRedirect('/mobile/danh-muc.html')}>
                <div className='col-12'>
                    <div className="bg-img-category view-more">
                        <img src="/../images/product/style_category_dot.png" alt="icon"/>
                    </div>
                </div>
                <div className='col-12 d-flex in-f pdt-5'><span className="text-item-category">Xem thêm</span></div>
            </div>
    </div>
    </div>

    <div className="row mgt-30">
        <div className="col-12 text-care in-f">
            <span>CÓ THỂ BẠN QUAN TÂM</span>
        </div>
    </div>

    <div className="row mgt-10 list-banner-category pdx-10 pdy-10">
        <div className="list-menu-category">
            <div className='row'>
                <div className={tabProduct === 0 ? ('col-12 pdx-0 in-f text-category select-text-red'):('col-12 pdx-0 in-f text-category')}>
                    <span onClick={()=>handleLoadProduct(0)}>Mẫu mới</span>
                </div>
            </div>
        </div>
        <div className="list-menu-category">
            <div className='row'>
                <div className={tabProduct === 1 ? ('col-12 pdx-0 in-f text-category select-text-red'):('col-12 pdx-0 in-f text-category')}>
                    <span onClick={()=>handleLoadProduct(1)}>Bán chạy</span>
                </div>
            </div>
        </div>
        <div className="list-menu-category">
            <div className='row'>
                <div className={tabProduct === 2 ? ('col-12 pdx-0 in-f text-category select-text-red'):('col-12 pdx-0 in-f text-category')}>
                    <span onClick={()=>handleLoadProduct(2)}>Yêu thích</span>
                </div>
            </div>
        </div>
        <div className="list-menu-category">
            <div className='row'>
                <div className={tabProduct === 3 ? ('col-12 pdx-0 in-f text-category select-text-red'):('col-12 pdx-0 in-f text-category')}>
                    <span onClick={()=>handleLoadProduct(3)}>Giảm giá</span>
                </div>
            </div>
        </div>
        <div className="list-menu-category">
            <div className='row'>
                <div className={tabProduct === 4 ? ('col-12 pdx-0 in-f text-category select-text-red'):('col-12 pdx-0 in-f text-category')}>
                    <span onClick={()=>handleLoadProduct(4)}>Đồng giá</span>
                </div>
            </div>
        </div>
    </div>

    <div className="row mgt-10 pdx-5">
        <ul className="row col-ul-1">
            {
                itemData.length>0 ?(
                    itemData.map((item, j)=>{
                        return <Item item={item} index={j}/>
                     })
                ):(<li>Không có dữ liệu</li>)
            }
        </ul>
        <InfiniteScroll loadMore={handleLoadMore} />
        { itemData.length > 6 && totalItem - itemData.length > 0? (
            <div className="loading-page-app-item pdy-5" style={{textAlign:"center"}}> <img src="/../images/loading.gif" alt="icon"/></div>
        ):(null)}
    </div>

   </Layout>
  )
}
export default Danhmuc;
